export default "__VITE_ASSET__BOnXfD4r__"